export default "__VITE_ASSET__VujlZ8M9__"